export const TERMS_OF_SERVICE = {
  TITLE_TEXT: 'Terms of Service',
  SUBTITLE_TEXT: 'Effective from: 7 June 2024',
};
